import type { FaireProductEntity } from "../../entity_types/product";

export const p_vvmpgpu2h9: FaireProductEntity = {
  token: "p_vvmpgpu2h9",
  type: "product",
  name: "Welcome Baby Gift Box - Charming 6-Piece Set for Newborns",
  brandToken: "b_9ikkew92sw",
  brandName: "Giften Market",
  imageUrl:
    "https://cdn.faire.com/fastly/40ddcfa8ff7a2291b06e853ff7aeca4a5d54aa6d43818e850f48c042630ca241.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/66a507815418121b5883b6b9f63bc442a2f30aa3be8381a89e5d18fa44882964.jpeg",
    "https://cdn.faire.com/fastly/054f6447ee2b17cf418a5f3da0fe012a1adbe6eb3b2c24985844108e28b5a517.png",
    "https://cdn.faire.com/fastly/de1286a79d263d15dac161e9fcbc5e2bf5a3825b771a1d4f852bc74f1bcdd22f.jpeg",
    "https://cdn.faire.com/fastly/fb29b416c62eaa8b31d90d075ff736867d6c039212047dc6e98a6bd819257773.jpeg",
    "https://cdn.faire.com/fastly/a65251527351732a2098553c1368a93906c3c539bd82bb92702d854b1af13be4.png",
    "https://cdn.faire.com/fastly/69520af85de810f2ddd51294d593b1480e0d9d6607b3d49c73dc13e424ec0f15.png",
    "https://cdn.faire.com/fastly/f4afa930cbeff09b60a372e5adc4799ea19cc52e37ea75c637c524483103be03.jpeg",
    "https://cdn.faire.com/fastly/a3cd18df4c702a7d1bf6274c0dc43d50ce645c3e1424da224b0251aa3f3003c5.png",
    "https://cdn.faire.com/fastly/69847f0b615944f525b13773601f92f822ead8ef2346a8cbc2d6a5bf0f24b9de.png",
    "https://cdn.faire.com/fastly/b10a4c8568bb27771f9b3fb2790eea93c225ee449912eeef6a6607d60a9d80e9.jpeg",
    "https://cdn.faire.com/fastly/f88d42509efa20bae1c64cbb87dc4f0f1312d24d9d2e4435311fdb798d9ad415.jpeg",
    "https://cdn.faire.com/fastly/3253c22ecc68ffcbb5c670a0d187cefac18a0636ffd49c77cccf00e79fc2bd58.jpeg",
    "https://cdn.faire.com/fastly/c997a8f54232d32ec28145d4f3e60b4a632a5fc78b629c33f9269b1cbec32baf.png",
    "https://cdn.faire.com/fastly/bb713834cbf08075431abcba338113870dd7260d1bb06c1d13a1417d5dbd0976.png",
    "https://cdn.faire.com/fastly/62e791c066f1d27fe3eed2f144b8af685b1f109013bfcae6fa7fb400a1913338.png",
    "https://cdn.faire.com/fastly/eb8207c6f5e325a4456577f940ca978652c4fabb773f239200cb4fcdd110462e.jpeg",
    "https://cdn.faire.com/fastly/06500a8c1880e4c5ee610a241a23458d16acf57035ae97ad05bcd73248399196.jpeg",
    "https://cdn.faire.com/fastly/1961eb59149508d0db13c248fafeb03dd37a6f2cd36832ba37ac65cf8e548b08.jpeg",
    "https://cdn.faire.com/fastly/7e3cdca14c023e96f5742c31e7673d7cd2f2e1667de462ad96965d55d9a75fe2.jpeg",
  ],
  priceDollars: 29,
  description:
    "Introducing our charming 6-piece Baby Gift Set, thoughtfully curated to delight both parents and their precious little ones. This ensemble includes everything a baby needs, beautifully presented in a rustic kraft box adorned with a clear lid and tied with a soft cotton ribbon.\n\nInside, you'll discover a collection of essentials designed for comfort and style, making it the perfect gift for baby showers or welcoming a new arrival.\n\nEach Gift Set Includes:\n- One Pacifier Clip\n- One Bamboo Baby Hairbrush\n- One Hello World Baby Announcement Sign\n- One Bunny Rattle\n- One Muslin Bandana Bib\n- One Muslin Organic Bamboo Swaddle",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:56.542Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
